import React from 'react';
import { Button, Radio, DatePicker, Input, Form, Select } from '@block/plug';
import { isString, isEqual, datejs } from '@block/utils';
import { doAction } from '../../utils';
import Url from './url';

interface Props {
  data: DefaultAny;
  // eslint-disable-next-line react/no-unused-prop-types
  ref: React.RefObject<DefaultAny>;
  onClose: () => void;
  onSubmit: (e: any) => void;
}
class Result extends React.Component<Props> {
  formRef = React.createRef<Form>();

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { data } = this.props;
    this.handleSetData(data);
  }

  componentWillReceiveProps(nextProps: Props) {
    const { data } = nextProps;
    const { data: propsData } = this.props;
    if (!isEqual(data, propsData)) {
      this.handleSetData(data);
    }
  }

  getPattern = (pattern?: string | RegExp) => {
    if (!pattern) {
      return null;
    }
    if (isString(pattern)) {
      return new RegExp(pattern);
    }
    return pattern as RegExp;
  };

  handleSetData = (data) => {
    this.formRef?.current?.setFieldsValue?.(data);
  };

  handleFieldValueChange = (code: string, value: string) => {
    const ref = this.formRef.current;
    if (code === 'certNumber') {
      // 证件号码
      // 证件号码
      let { birthday, birthdayStr, gender } = ref.getFieldsValueIncludeHide();
      const { certTypeDictIndex } = ref.getFieldsValueIncludeHide();
      if (certTypeDictIndex === 'NID' && value.length === 18) {
        const year = value.substring(6, 10);
        const month = value.substring(10, 12);
        const day = value.substring(12, 14);
        const date = [year, month, day].join('-');
        birthday = new Date(date).getTime();
        birthdayStr = [year, month, day].join('-');
        gender = parseInt(value.substring(17, 1), 10) % 2 ? 'M' : 'F';
        ref.clearValidateStatus(['gender', 'birthday']);
      } else if (certTypeDictIndex === 'OLDNID' && value.length === 15) {
        const year = `19${value.substring(6, 8)}`;
        const month = value.substring(8, 10);
        const day = value.substring(10, 12);
        const date = [year, month, day].join('-');
        birthday = new Date(date).getTime();
        birthdayStr = [year, month, day].join('-');
        gender = parseInt(value.substring(14, 1), 10) % 2 ? 'M' : 'F';
        ref.clearValidateStatus(['gender', 'birthday']);
      }
      ref?.setFieldsValue({
        certNumber: value,
        birthday,
        birthdayStr,
        gender,
        genderDictName: value === 'M' ? '男' : '女',
      });
    }

    if (code === 'birthday') {
      // 生日
      ref?.setFieldsValue({
        birthdayStr: datejs(value).format('YYYY-MM-DD'),
      });
    }

    if (code === 'gender') {
      // 性别
      ref?.setFieldsValue({
        genderDictName: value === 'M' ? '男' : '女',
      });
    }

    if (code === 'registerProvinceDictIndex') {
      // 户口所在地 省份
      ref?.setFieldsValue({
        registerCityDictIndex: null,
        registerCityDictName: null,
      });
    }
  };

  handleClose = () => {
    const { onClose } = this.props;
    onClose?.();
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const ref = this.formRef.current;
    const data = ref.getFieldsValueIncludeHide();
    for (const key in data) {
      if (!data[key]) {
        // eslint-disable-next-line
        delete data[key];
      }
    }
    delete data.ocrState;
    onSubmit?.(data);
  };

  // 获取国籍
  handleFetchNationality = async (filter = '') => {
    const data = await doAction(
      Url.getNationality,
      {
        filter,
      },
      null,
    );
    return data.pageList;
  };

  // 获取省份
  handleFetchProvince = async (filter = '') => {
    const data = await doAction(Url.getProvince, {
      filter,
      parentIndex: 'CHN',
    });
    return data.pageList;
  };

  // 获取城市
  handleFetchCity = async (filter = '', province = undefined) => {
    if (province) {
      const data = await doAction(Url.getCity, {
        filter,
        parentExtIndex: 'CHN',
        parentIndex: province,
      });
      return data.pageList;
    }
    return [];
  };

  // 获取民族
  handleFetchNationData = async (filter = '') => {
    const { nationalityDictIndex } = this.formRef.current.getFieldsValueIncludeHide();
    if (nationalityDictIndex) {
      const data = await doAction(Url.getNation, {
        filter,
        parentIndex: nationalityDictIndex,
      });
      return data.pageList;
    }
    return [];
  };

  render() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    return (
      <div className="ocr-result">
        <div className="tip">请核查以下识别结果，如有错误，可修改后应用</div>
        <Form
          ref={this.formRef}
          labelWidth="70px"
          labelPosition="left"
          onFieldValueChange={this.handleFieldValueChange}
        >
          <Form.Item
            formItemKey="certTypeDictIndex"
            labelInValue={false}
            formItemLabel="certTypeDictName"
            span={11}
            label="证件类型："
            message="不能为空"
            labelPosition="top"
          >
            <Select
              toFormItem
              keyField="dictIndex"
              labelField="dictValue"
              onFetchData={() => []}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              disabled
            />
          </Form.Item>
          <Form.Item
            formItemKey="certNumber"
            span={11}
            labelWidth="70px"
            label="证件号码："
            labelPosition="top"
            offset={2}
            rules={[
              { required: true, message: '证件号码不能为空' },
              {
                validator(rule, value, callback) {
                  const { certTypeDictIndex } = self.formRef.current.getFieldsValueIncludeHide();
                  let str;
                  if (certTypeDictIndex === 'NID') {
                    str =
                      '^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$';
                  } else if (certTypeDictIndex === 'OLDNID') {
                    str = '^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}$';
                  } else {
                    str = '^[0-9a-zA-Z]+$';
                  }
                  const pattern = this.getPattern(str);
                  if (pattern && !pattern.test(value)) {
                    callback('请输入有效的证件号码');
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <Input toFormItem placeholder="请输入" />
          </Form.Item>

          <Form.Item formItemKey="birthday" span={11} labelWidth="45px" label="生日：" labelPosition="top">
            <DatePicker toFormItem valueFormat="timestamp" />
          </Form.Item>

          <Form.Item
            formItemKey="gender"
            span={11}
            offset={2}
            labelWidth="45px"
            label="性别："
            labelPosition="top"
            required
            message="不能为空"
          >
            <Radio.Group toFormItem>
              <Radio value="M">男</Radio>
              <Radio value="F">女</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            formItemKey="nationalityDictIndex"
            labelInValue={false}
            formItemLabel="nationalityDictName"
            span={11}
            labelWidth="45px"
            label="国籍："
            labelPosition="top"
          >
            <Select
              toFormItem
              filterable
              disabled
              keyField="dictIndex"
              labelField="dictValue"
              onFetchData={() => []}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
            />
          </Form.Item>

          <Form.Item
            formItemKey="nationDictIndex"
            labelInValue={false}
            formItemLabel="nationDictName"
            span={11}
            offset={2}
            required
            labelWidth="45px"
            message="不能为空"
            label="民族："
            labelPosition="top"
          >
            <Select
              toFormItem
              filterable
              keyField="dictIndex"
              labelField="dictValue"
              onFetchData={(filter) => this.handleFetchNationData(filter)}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
            />
          </Form.Item>

          <Form.Item
            formItemKey="registerProvinceDictIndex"
            labelInValue={false}
            formItemLabel="registerProvinceDictName"
            span={11}
            labelWidth="90px"
            label="户口所在地："
            labelPosition="top"
          >
            <Select
              toFormItem
              filterable
              keyField="dictIndex"
              labelField="dictValue"
              onFetchData={(filter) => this.handleFetchProvince(filter)}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
            />
          </Form.Item>
          <Form.Item
            formItemKey="registerCityDictIndex"
            labelInValue={false}
            formItemLabel="registerCityDictName"
            span={11}
            offset={2}
            label="&nbsp;"
            required
            message="不能为空"
            labelPosition="top"
          >
            <Select
              toFormItem
              filterable
              keyField="dictIndex"
              labelField="dictValue"
              onFetchData={(filter) => {
                const { registerProvinceDictIndex } = self.formRef.current.getFieldsValueIncludeHide();
                return this.handleFetchCity(filter, registerProvinceDictIndex);
              }}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
            />
          </Form.Item>

          <Form.Item formItemKey="registerAddress" span={24} labelPosition="top" label="详细地址：">
            <Input toFormItem maxLength={255} />
          </Form.Item>
        </Form>
        <div className="ocr-result__button">
          <Button onClick={this.handleClose}>取消</Button>
          <Button onClick={this.handleSubmit} type="primary">
            应用
          </Button>
        </div>
      </div>
    );
  }
}

export default Result;
